import * as React from 'react';
import { BuyConfirmationModalContainer } from '../BuyConfirmationModal';
import { BuyResultModalContainer } from '../BuyResultModal';
import { useSelector } from 'react-redux';
import { EBuyPackageStatus } from '../../types';
import { selectBuyPackageModalStatus, selectIsBuyPackageModalVisible } from '../../selectors/buyPackageModal';

export const BuyModalContainer = () => {
  const isVisible = useSelector(selectIsBuyPackageModalVisible);
  const status = useSelector(selectBuyPackageModalStatus);

  if (!isVisible) {
    return null;
  }

  if (status === EBuyPackageStatus.Confirm) {
    return <BuyConfirmationModalContainer />;
  }

  return <BuyResultModalContainer />;
};
